// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:46:41

export default {
  "id": "run-n-shoot",
  "slug": "run-n-shoot",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c4a3ba03a97e41dcb2f09f7b5ee0fa49-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c4a3ba03a97e41dcb2f09f7b5ee0fa49/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Run N Shoot",
      "description": "You run and you shoot. That’s all you do, but this deceptively simple game mixes up the action and racks up the adrenalin with surprises round every corner to ensure you never get bored. Trigger finger itchy?",
      "instructions": "You’ll need to have all your wits about you and pistols at the ready to keep on running ? and keep on gunning. Enemies appear on all sides, and you have to take them down before they open fire on you to survive. Use explosives, extinguishers, and utility pipes to deal extra damage and take out multiple enemies with a single shot. Just make sure you don’t hit the innocent civilians you were sent here to save!",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "3d",
        "agent",
        "guns",
        "run",
        "runner"
      ]
    },
    "zh-CN": {
      "title": "奔跑射击",
      "description": "你跑，你射击。这就是你做的所有事情，但这款看似简单的游戏通过在每个角落设置惊喜来混合动作，积累肾上腺素，确保你永远不会感到无聊。手指痒了吗？",
      "instructions": "你需要全神贯注，手枪随时待命，继续奔跑和射击。敌人从四面八方出现，你必须在他们开火之前将其击倒以生存。使用炸药、灭火器和工具管道造成额外伤害，一枪击倒多个敌人。只需确保不要击中那些你被派来拯救的无辜平民！",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "三维",
        "代理",
        "枪械",
        "奔跑",
        "跑酷者"
      ]
    },
    "zh-TW": {
      "title": "奔跑射擊",
      "description": "你奔跑、你射擊。這就是你所做的全部，但這款看似簡單的游戏卻在每個角落都設有驚喜，混搭動作並釋放肾上腺素，確保你從不感到無聊。觸發手指癢了嗎？",
      "instructions": "你需要全神貫注，手槍準備妥當，不停地奔跑和射擊。敵人從四面八方出現，你必須在他們向你開火前將他們擊敗以維持生命。使用炸藥、滅火器以及工具管來造成額外傷害，並一次性擊敗多名敵人。只不過要確保你別傷及無辜的平民，你被派遣到這裡是為了拯救他們的！",
      "genres": [
        "休闲",
        "射擊"
      ],
      "tags": [
        "3D",
        "代理",
        "槍械",
        "奔跑",
        "跑者"
      ]
    },
    "zh-HK": {
      "title": "跑射",
      "description": "你跑你射。這就是你所做的所有事情，但這款看似簡單的遊戲卻將動作混搭，帶來驚喜不斷，讓你無法感到無聊。觸發指頭癢了嗎？",
      "instructions": "你需要全神貫注，手槍準備就緒，持續奔跑並持續射擊。敵人從四面八方出現，你必須在他們對你開火前將他們擊倒以保證生存。使用炸藥、滅火器及公用管線造成額外傷害，並單擊擊倒多名敵人。只需確保不要擊中那些你被派遣來拯救的无辜平民即可！",
      "genres": [
        "隨意",
        "射擊"
      ],
      "tags": [
        "3D",
        "代理",
        "槍械",
        "奔跑",
        "跑者"
      ]
    },
    "ja": {
      "title": "ラン・アンド・シュート",
      "description": "走って撃つ。それだけですが、この見かけ上シンプルなゲームは、アクションを混ぜ合わせて、隅々に驚きがあり、飽きることがないようにアドレナリンを高めています。指先がitchy（指がitchyになる）？",
      "instructions": "知恵を絞り、手に入れたピストルを用意し、走り続け、銃撃を続ける必要があります。敵は四面八方に現れ、彼らが銃撃を始める前に倒さなければ生存できません。爆発物、消火器、ユーティリティパイプを使って追加ダメージを与え、一撃で複数の敵を倒しましょう。ただし、救出すべき無辜の市民を傷つけないように気をつけてください！",
      "genres": [
        "カジュアル",
        "シューティング"
      ],
      "tags": [
        "3D",
        "エージェント",
        "銃",
        "走る",
        "ランナー"
      ]
    },
    "ko": {
      "title": "런앤샷",
      "description": "당신은 뛰고 쏜다. 그것이 전부입니다만, 이 유혹적으로 간단한 게임은 행동을 혼합하여 각 단서마다 놀라움으로 기쁨을 쌓아놓아 지루해질 시간이 없도록 합니다. 트리거 지퍼가 간지럽혀지셨나요?",
      "instructions": "모든 지혜를 모아 총기를 준비하고 계속 도망치고, 계속 쏘아야 합니다. 적들이 모든 방향에서 나타나서, 그들이 총을 쏘기 전에 그들을 쓰러뜨려야 생존할 수 있습니다. 폭발물, 소화기, 유용한 파이프를 사용하여 추가적인 데미지를 입히고 한 발로 여러 적을 쓰러뜨리세요. 하지만, 구하기 위해 보낸 무辜의 시민을 맞추지 마세요!",
      "genres": [
        "캐주얼",
        "셔터"
      ],
      "tags": [
        "3D",
        "에이전트",
        "소총",
        "달리기",
        "러너"
      ]
    },
    "fr": {
      "title": "Course et tire",
      "description": "Vous courez et vous tirez. C'est tout ce que vous faites, mais ce jeu apparemment simple mélange l'action et accumule l'adrénaline avec des surprises à chaque coin pour s'assurer que vous ne vous ennuyez jamais. Doigt gêné?",
      "instructions": "Vous devrez être vigilant et avoir vos pistolets prêts pour continuer à courir et à tirer. Les ennemis apparaissent de toutes parts, et vous devez les abattre avant qu'ils ne vous tirent dessus pour survivre. Utilisez des explosifs, des extincteurs et des tuyaux utiles pour infliger des dommages supplémentaires et abattre plusieurs ennemis d'un seul tir. Assurez-vous juste de ne pas toucher les civils innocents que vous avez été envoyé sauver !",
      "genres": [
        "Facile",
        "Tirez"
      ],
      "tags": [
        "3D",
        "agent",
        "armes",
        "course",
        "coureur"
      ]
    }
  }
};
